import React from 'react';
import { Zap } from 'lucide-react';
import { useCountdown, CountdownDisplay } from './Countdown';
export function TopBar() {
  const {
    minutes,
    seconds
  } = useCountdown(14, 54);
  return <div className="sticky top-0 z-50 w-full bg-navy text-white py-2 px-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm font-medium shadow-md" data-id="element-242">
      <div className="flex items-center gap-2 text-center" data-id="element-243">
        <Zap className="w-4 h-4 text-primary fill-primary" data-id="element-244" />
        <span data-id="element-245">Oferta de lanzamiento — acceso de por vida</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-246">
        <span className="opacity-90" data-id="element-247">termina en</span>
        <CountdownDisplay minutes={minutes} seconds={seconds} data-id="element-248" />
      </div>
    </div>;
}